import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { PlanoSaude, SalvarPessoa, TipoParentesco, TipoPlano, TipoSolicitacao } from "app/model/solicitacaoAuxSaude";
import { SolicitacaoAuxSaudeService } from 'app/service/solicitacao-aux-saude/solicitacao-aux-saude.service';
import { debounceTime } from 'rxjs/operators';

import 'moment/locale/pt';
import { MaskUtil } from 'app/utils/mask-util';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { ModalAnexoComponent } from '../modal-anexo/modal-anexo.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalExcluirComponent } from 'app/components/modal-excluir/modal-excluir.component';
import { ModalAvisoComponent } from '../modal-aviso/modal-aviso.component';
import { MatPaginator } from '@angular/material/paginator';
import { ActivatedRoute } from '@angular/router';
import { forkJoin, Observable } from "rxjs";
import { ValidaDto } from 'app/model/valida.dto';
import { EnumService } from "../../service/enum/enum";
import { Enum } from "../../model/enum";
@Component({
  selector: 'app-tipo-solicitacao',
  templateUrl: './tipo-solicitacao.component.html',
  styleUrls: ['./tipo-solicitacao.component.sass']
})
export class TipoSolicitacaoComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() listaTipoSolicitacao: TipoSolicitacao[];
  @Output() listaRequisicoes: EventEmitter<any> = new EventEmitter<any>();
  @Input() permiteEdicao: boolean;
  @Input() solicitacaoId: number;
  @Output() idNovaSolicitacao: EventEmitter<any> = new EventEmitter<any>();

  listaTipoParentesco: TipoParentesco[];
  listaEstadoCivil: Enum[];
  listaTipoCapacidade: Enum[];
  listaTipoPlanos: TipoPlano[];
  filteredOptions: PlanoSaude[] = []
  filteredOptionsCpf: any[] = []
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  visualizar: boolean = false
  displayedColumns: string[] = ['nomeCompleto', 'cpf', 'dependente', 'relacaoDependencia', 'tipoPlano', 'nomePlano', 'valor', 'acoes']
  totalElements: number = 0;
  pageSize: number = 5;
  click: boolean = false;
  clickPlano: boolean = false;
  editElement = null;
  modoEdicao: boolean = false;
  disabledBtnIncluir: boolean = false;

  private readonly CAMPOS_FORMULARIO_DEPENDENTE = [
    'cpfDependente',
    'nomeDependente',
    'dataNascimentoDependente',
    'tipoParentesco',
    'sexo', 'estadoCivil', 'tipoCapacidade', 'dataInvalidez'
  ];

  private readonly CAMPOS_FORMULARIO_PLANO = ['tipoSolicitacao', 'tipoPlano', 'nomePlano', 'valorPlano'];

  constructor(
    private solicitacaoAuxSaudeService: SolicitacaoAuxSaudeService,
    private enumService: EnumService,
    private toasterService: ToastrService,
    public dialog: MatDialog,
    private route: ActivatedRoute,) { }

  ngOnInit(): void {
    this.solicitacaoId = this.extractIdFromUrl();
    if(this.solicitacaoId && !this.permiteEdicao){
      this.displayedColumns.pop();
      this.visualizar = true
    }
    this.form.get('nomePlano').valueChanges.pipe(
      debounceTime(1000)
    ).subscribe(value => {
      if (
        this.form.get('nomePlano').value?.length > 0 &&
        this.form.get('nomePlano').value?.trim() !== '' &&
        !this.clickPlano
      ) {
        if(this.form.get('tipoPlano').value !== null){
          //this.form.get('idPlano').setValue(null)
          this.findPlanoSaude();
        }
        else{
          this.form.get('nomePlano').setValue(null)
          this.toasterService.warning("Por favor, selecione o tipo de plano de digitar o nome do plano.")
        }
      }
      else {
        this.clickPlano = false
      }
    });

    this.form.get('cpfDependente').valueChanges.pipe(
      debounceTime(1000)
    ).subscribe(value => {
      if (
        this.form.get('cpfDependente').value?.length > 0 &&
        this.form.get('cpfDependente').value?.trim() !== '' &&
        !this.click
      ) {
        this.desbloquearCampos()
        //this.form.get('idDependente').setValue(null)
        this.findCpfDependente();
      }
      else {
        this.click = false
      }
    });
    this.loadDados()
  }

  extractIdFromUrl(): number {
    return this.route.snapshot.params.id ?? null;
  }

  loadDados() {
    const tipoPLano$: Observable<TipoPlano[]> = this.getTipoPlanos();
    const tipoParentesco$: Observable<TipoParentesco[]> = this.getTipoParentesco();
    const estadoCivil$: Observable<Enum[]> = this.getEstadoCivil();
    const tipoCapacidade$: Observable<Enum[]> = this.getTipoCapacidade();
    forkJoin([tipoPLano$, tipoParentesco$, estadoCivil$, tipoCapacidade$ ])
      .pipe()
      .subscribe(
        ([tipoPLano, tipoParentesco, estadoCivil, tipoCapacidade]) => {
          this.listaTipoPlanos = tipoPLano;
          this.listaTipoParentesco = tipoParentesco;
          this.listaEstadoCivil = estadoCivil;
          this.listaTipoCapacidade = tipoCapacidade;
          this.getGrid();
        },
        (error) => {
          this.toasterService.error(error.error.message)
        }
      );

  }

  getTipoPlanos(): Observable<TipoPlano[]>{
    return this.solicitacaoAuxSaudeService.getTipoPlanos()
  }

  getTipoParentesco(): Observable<TipoParentesco[]>{
    return this.solicitacaoAuxSaudeService.getTipoParentesco()
  }

  getEstadoCivil(): Observable<Enum[]>{
    return this.enumService.buscarEstadoCivil();
  }

  getTipoCapacidade(): Observable<Enum[]>{
    return this.solicitacaoAuxSaudeService.getTipoCapacidade();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  findPlanoSaude() {
    this.solicitacaoAuxSaudeService.getPlanoSaude(this.form.get("nomePlano").value.toUpperCase(),this.form.get("tipoPlano").value).subscribe((result) => {
      this.filteredOptions = result;
    })
  }

  findCpfDependente() {
    this.solicitacaoAuxSaudeService.getCpfDependente(this.form.get("cpfDependente").value).subscribe((result) => {
      this.filteredOptionsCpf = result.map(item => {
        let cpf
        if (typeof item.cpf === 'number') {
          cpf = item.cpf.toString()
          if (cpf.length === 10) {
            cpf = '0' + cpf
          }
        }
        return { ...item, cpf }
      });
    })
  }

  onOptionSelected(event) {
    this.clickPlano = true
    this.form.get('idPlano').setValue(event.id)
    this.filteredOptions = []
  }

  onOptionSelectedCpf(event) {
    this.click = true
    this.form.get('idDependente').setValue(event.numeDependente)
    this.form.get('nomeDependente').setValue(event.nomeDependente)
    this.form.get('dataNascimentoDependente').setValue(event.dataNascimento)
    this.form.get('tipoParentesco').setValue(event.tipoParentescoId)
    this.form.get('nomeDependente').disable()
    this.form.get('dataNascimentoDependente').disable()
    this.form.get('tipoParentesco').disable()
    this.form.get('sexo').setValue(event.sexo)
    this.form.get('estadoCivil').setValue(event.estadoCivil)
    this.form.get('tipoCapacidade').setValue(event.tipoCapacidade)
    this.form.get('dataInvalidez').setValue(event.dataInvalidez)
    this.filteredOptionsCpf = []
    this.changeTipoParentesco();
  }

  desbloquearCampos() {
    const campos = ['nomeDependente', 'dataNascimentoDependente', 'tipoParentesco']
    campos.forEach(campo => {
      this.form.get(campo).enable()
      !this.modoEdicao && this.form.get(campo).setValue(null)
    })
  }

  changeTipoParentesco() {
    this.listaTipoParentesco.find( tp => {
      if(tp.codigo ==  this.form.get('tipoParentesco').value && tp.descricao == "FILHO INVÁLIDO/A") {
        this.listaTipoCapacidade.find( tc => {
          tc.descricao == "INVÁLIDO" && this.form.get('tipoCapacidade').setValue(tc.codigo);
          this.form.get('dataInvalidez').setValidators(Validators.required);
        })
      } else {
        this.form.get('tipoCapacidade').setValue(null);
      }
    })
  }

  changeCapacidade($event: any) {
    if($event.source.value == 3){
      this.form.get('dataInvalidez').setValidators(Validators.required);
    } else {
      this.form.get('dataInvalidez').clearValidators();
      this.form.get('dataInvalidez').updateValueAndValidity();
    }
  }

  mudancaTemDependende(event) {
    let campos = ['cpfDependente', 'nomeDependente', 'dataNascimentoDependente', 'tipoParentesco']
    if (event.value) {
      campos.forEach(campo => {
        if (campo === 'cpfDependente') {
          this.form.get(campo).setValidators([Validators.required, MaskUtil.validateCpfFormBuilder]);
        }
        else {
          this.form.get(campo).setValidators(Validators.required);
        }
        this.form.get(campo).updateValueAndValidity();
      })
    }
    else {
      campos.forEach(campo => {
        this.form.get(campo).setValue(null);
        this.form.get(campo).clearValidators();
        this.form.get(campo).updateValueAndValidity();
      })
    }
  }

  limparFiltros() {
    const camposLimpar = [...this.CAMPOS_FORMULARIO_DEPENDENTE, ...this.CAMPOS_FORMULARIO_PLANO]
    camposLimpar.forEach(campo => {
      this.form.get(campo).setValue(null);
    })
    const camposHabilitar = ['nomeDependente', 'dataNascimentoDependente', 'tipoParentesco']
    camposHabilitar.forEach(campo => {
      this.form.get(campo).enable()
    })
  }

  validacao(ativar: boolean): boolean {
    let campos = this.CAMPOS_FORMULARIO_PLANO
    if (ativar) {
      campos.forEach(campo => {
        this.form.get(campo).setValidators(Validators.required);
        this.form.get(campo).updateValueAndValidity();
      })
      if (this.form.get('dependente').value) {
        campos = campos.concat(this.CAMPOS_FORMULARIO_DEPENDENTE)
      }
      const valid = !campos.some((field) => {
        //console.log(field, typeof this.form.get(field).value === 'string', this.form.get(field).value?.length > 0, this.form.get(field));

        if (typeof this.form.get(field).value === 'string' && this.form.get(field).value?.length > 0 && !this.form.get(field).errors) {
          return this.form.get(field).value.trim() === ''
        }
        if (this.form.get(field).errors?.required) {
          this.toasterService.warning("Por favor, preencha os campos obrigatórios")
        }
        else if (field === 'cpfDependente' && this.form.get(field).errors?.cpfValid) {
          this.toasterService.warning("O CPF do dependente inserido não é válido")
        }
        return this.form.get(field).errors
      })
      if (!valid) {
        return false
      }
      if (
        this.dataSource.data.some(row =>
          !this.editElement && //Não seja Edição
          row.nomePlano === this.form.get('nomePlano').value && //Mesmo plano
          (
            row.cpf === this.form.get('cpfDependente').value || // Mesmo CPF
            (
              !this.form.get('dependente').value &&  // Caso não seja dependente
              row.cpf === this.form.get('cpf').value // Mesmo CPF do titular
            )
          ) &&
          row.tipoPlano === this.listaTipoPlanos?.find(plano => plano.codigo === this.form.get('tipoPlano').value)?.descricao
        )
      ) {
        this.toasterService.warning("Já existe um registro com o mesmo tipo de plano para o titular/dependente. Por favor, verifique e tente novamente.");
        return false
      }
      return true
    }
    else {
      if (this.form.get('dependente').value) {
        campos = campos.concat(this.CAMPOS_FORMULARIO_DEPENDENTE)
      }
      campos.forEach(campo => {
        this.form.get(campo).clearValidators();
        this.form.get(campo).updateValueAndValidity();
      })
      return true
    }
  }

  incluirTabela() {

    if (this.validacao(true)) {
      let obj
      let id = this.editElement ? this.editElement.id : null
      const dependente = this.form.get('dependente').value
      obj = {
        id: id,
        nomeCompleto: dependente ? this.form.get('nomeDependente').value : this.form.get('nome').value,
        cpf: dependente ? this.form.get('cpfDependente').value : this.form.get('cpf').value,
        dependente: dependente ? "Sim" : "Não",
        tipoPlano: this.form.get('tipoPlano').value,
        nomePlano: this.form.get('nomePlano').value,
        valor: this.form.get('valorPlano').value,
        //Extras
        tipoSolicitacao: this.form.get('tipoSolicitacao').value,
        idPlano: this.form.get('idPlano').value,
        dataNascimento: dependente ? this.form.get('dataNascimentoDependente').value : this.form.get('dataNascimento').value,
        tipoParentesco: dependente ? this.form.get('tipoParentesco').value : null,
        idDependente: dependente ? this.form.get('idDependente').value : null,
        sexo: dependente ? this.form.get('sexo').value : null,
        estadoCivil: dependente ? this.form.get('estadoCivil').value : null,
        tipoCapacidade: dependente ? this.form.get('tipoCapacidade').value : null,
        dataInvalidez: dependente ? this.form.get('dataInvalidez').value : null
      }
      this.disabledBtnIncluir = true;
      this.envio(obj)
    }
  }

  envio(obj) {
    const dependente = obj.dependente === "Sim"
    const data = {
      id: this.dataSource.data.length == 0 && this.solicitacaoId == null ? null : this.solicitacaoId,
      tipoSolicitacao: obj.tipoSolicitacao,
      flagDependente: dependente,
      solicitacaoTitularId: dependente? null : obj.id,
      solicitacaoDependenteId: dependente? obj.id :null,
      idDependente: obj.idDependente,
      tipoPlanoSaude: obj.tipoPlano,
      nomePlanoSaude: obj.nomePlano,
      idPlanoSaude: obj.idPlano,
      valorPlanoSaude: obj.valor,
      cpf: obj.cpf,
      nome: obj.nomeCompleto,
      tipoParentesco: obj.tipoParentesco,
      dataNascimento: obj.dataNascimento ? new Date(obj.dataNascimento) : null,
      sexo: obj.sexo,
      estadoCivil: obj.estadoCivil,
      tipoCapacidade: obj.tipoCapacidade,
      dataInvalidez: obj.dataInvalidez
    }

    this.solicitacaoAuxSaudeService.validaSolicitacaoInativo(data).subscribe( async resp => {
      if(resp.valido){
        const isValid = await this.validaPlano();

        if(!isValid) {
          this.disabledBtnIncluir = false;
          return ;
        }
      }

      this.solicitar(data);

    })

  }

  private solicitar(data: SalvarPessoa) {
    this.solicitacaoAuxSaudeService.setPessoa(data).subscribe((result) => {
        this.solicitacaoId = result.id;
        this.idNovaSolicitacao.emit(this.solicitacaoId);
        console.log(this.solicitacaoId, result);

        this.editElement = null;
        this.getGrid();
        this.validacao(false);
        this.limparFiltros();
        this.disabledBtnIncluir = false;
      },
      (error) => {
        this.disabledBtnIncluir = false;
        this.toasterService.error(error.error.message);
      });
  }

  getGrid() {
    this.dataSource.data = [];
    this.dataSource._updateChangeSubscription();
    this.solicitacaoId &&
      this.solicitacaoAuxSaudeService.getEditarVisualizar(this.solicitacaoId).subscribe((result) => {
      result.titular?.forEach(element => {
        const data = {
          id: element.id,
          nomeCompleto: element.nome,
          cpf: element.cpf,
          dependente: "Não",
          tipoPlano: this.listaTipoPlanos?.find(plano => plano.codigo === element.tipoPlanoId)?.descricao,
          tipoPlanoId: element.tipoPlanoId,
          nomePlano: element.nomePlanoSaude,
          valor: element.valor,
          //Extras
          tipoSolicitacao: element.tipoSolicitacaoId,
          idPlano: null, // faltou
          dataNascimento: element.dataNascimento,
          tipoParentesco: null,
          relacaoDependencia: "TITULAR",
          idDependente: null,//Faltou
        }
        this.dataSource.data.push(data)
      })
      result.dependentes?.forEach(element => {
        const data = {
          id: element.id,
          nomeCompleto: element.nome,
          cpf: element.cpf,
          dependente: "Sim",
          tipoPlano: this.listaTipoPlanos?.find(plano => plano.codigo === element.tipoPlanoId)?.descricao,
          tipoPlanoId: element.tipoPlanoId,
          nomePlano: element.nomePlanoSaude,
          valor: element.valor,
          //Extras
          tipoSolicitacao: element.tipoSolicitacaoId,
          idPlano: null,
          dataNascimento: new Date(element.dataNascimento),
          tipoParentesco: element.tipoParentescoId,
          relacaoDependencia: this.listaTipoParentesco?.find(parentesco => parentesco.codigo === element.tipoParentescoId)?.descricao,
          idDependente: element.id,
          sexo: element.sexo,
          estadoCivil: element.estadoCivil,
          tipoCapacidade: element.tipoCapacidade,
          dataInvalidez: new Date(element.dataInvalidez)
        }
        this.dataSource.data.push(data)
      })
      this.totalElements = this.dataSource.data.length;
      this.dataSource.data.sort((a, b) => a.nomeCompleto.localeCompare(b.nomeCompleto));
      this.dataSource._updateChangeSubscription()
      this.listaRequisicoes.emit(this.dataSource.data)
    })
  }

  edit(element) {
    this.modoEdicao = true
    this.editElement = element;
    this.form.get('tipoSolicitacao').setValue(element.tipoSolicitacao);
    this.form.get('tipoPlano').setValue(element.tipoPlanoId);
    this.form.get('nomePlano').setValue(element.nomePlano);
    this.form.get('idPlano').setValue(element.idPlano);
    this.form.get('valorPlano').setValue(element.valor);
    if (element.dependente === "Não") {
      this.form.get('dependente').setValue(false);
      this.form.get('cpfDependente').setValue(null);
      this.form.get('nomeDependente').setValue(null);
      this.form.get('dataNascimentoDependente').setValue(null);
      this.form.get('tipoParentesco').setValue(null);
    }
    else {
      this.form.get('dependente').setValue(true);
      this.form.get('cpfDependente').setValue(element.cpf);
      this.form.get('nomeDependente').setValue(element.nomeCompleto);
      this.form.get('dataNascimentoDependente').setValue(element.dataNascimento);
      this.form.get('tipoParentesco').setValue(element.tipoParentesco);
      this.form.get('sexo').setValue(element.sexo);
      this.form.get('estadoCivil').setValue(element.estadoCivil);
      this.form.get('tipoCapacidade').setValue(element.tipoCapacidade);
      this.form.get('dataInvalidez').setValue(element.dataInvalidez);
    }
  }

  delete(element) {
    this.solicitacaoAuxSaudeService.deletarPessoa(
      {
        id: element.id,
        isDependente: element.dependente === "Sim"
      }
    ).subscribe((result) => {
      this.getGrid();
    }),
      (error) => {
        console.log(error);

        this.toasterService.error(error.error.message)
      }
  }

  abrirDocumentacaoNecessaria() {
    //this.openDialogAvisoAnexos(null)
  }

  openDialogAvisoAnexos(): void {
    this.dialog.open(ModalAvisoComponent, {
      width: '958px',
    });
  }

  abrirListaAnexos(pessoa) {
    this.openDialogListaAnexos(pessoa)
  }
  openDialogListaAnexos(pessoa): void {
    this.dialog.open(ModalAnexoComponent, {
      width: '958px',
      data: {
        titulo: `Anexar / Visualizar Documentos - ${pessoa.nomeCompleto}`,
        id: pessoa.id,
        isDependente: pessoa.dependente === "Sim",
        tipoParentesco: pessoa.tipoParentesco ? pessoa.tipoParentesco : "",
        dataNascimento: pessoa.dataNascimento,
        tipoPlano: pessoa.tipoPlanoId,
        cpf: pessoa.dependente === "Sim" ? pessoa.cpf : "",
        visualizar: this.visualizar,
        anexar: (file: FormData) => {
          //this.getFormData(null)

        }
      }
    });
  }

  openDialogExcluir(pessoa): void {
    this.dialog.open(ModalExcluirComponent, {
      width: '500px',
      data: {
        titulo: "Excluir Solicitação",
        mensagem: "Deseja excluir a Solicitação?",
        botaoOk: "Sim",
        botaoCancelar: "Não",
        acaoOk: () => {
          //this.getFormData(null)
          this.delete(pessoa)
        }
      }
    });
  }

  async openDialogConfirm(): Promise<boolean> {
    const dialogRef = this.dialog.open(ModalExcluirComponent, {
      width: '500px',
      disableClose: true,
      data: {
        titulo: 'Atenção!',
        mensagem: 'O auxílio saúde para os planos de saúdes Planserv e SulAmérica são concedidos automaticamente. Deseja continuar?',
        botaoOk: "Sim",
        botaoCancelar: "Não",
        acaoOk: () => {
          dialogRef.close(true);
        }
      }
    });

    return await dialogRef.afterClosed().toPromise();
  }

  async validaPlano(): Promise<boolean> {
    const confirmation = await this.openDialogConfirm();

    if (confirmation) {
      return confirmation;
    }
    return false;
  }
}
